
import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { TokenInterceptor } from "app/authorized-http.service";
import { UtilsService } from "app/services/utils.service";
import { Observable } from "rxjs";
import { MTemplateDataListResource } from "app/models/mtemplate-data-list-resource";
import { MTemplateDataResource } from "app/models/MTemplateDataResource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class NewsletterListService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  getNewsletters(): Observable<MTemplateDataListResource> {
    return this.http.get<MTemplateDataListResource>(environment['url'] + '/templateEditor/templates'+ "?userEmail="+this.utilsService.currentUserEmail)
  }

  deleteTemplate(templateId): Observable<MTemplateDataResource> {
    return this.http.get<MTemplateDataResource>(environment['url'] + '/templateEditor/delete/' + templateId+"?userEmail="+this.utilsService.currentUserEmail);
  }

  sendMail(templateId, isExternal): Observable<MTemplateDataResource> {
    return this.http.get<MTemplateDataResource>(environment['url'] + '/templateEditor/send/' + templateId + "?isExternal="+isExternal+"&userEmail="+this.utilsService.currentUserEmail)
  }

}
